import { createSelector } from '@reduxjs/toolkit';
import { emptyObj } from '@beef/utils';
import { AVAILABLE_STATUSES, POPUP_CONNECTION_STATE, orderTariffPopupNames, orderTariffPopupSteps, popupSteps, resultPopupActionButton } from "../../../../../store/common/constants";
import { selectUserCtn } from "../../../../../store/callbackRequest/selectors";
import { selectIsCheckboxChecked } from "../../../../../store/CheckboxAgreement/selectors";
import { getAddressData, getConnectionStatus, getModalTariffData, getOrderTariffTexts } from "./orderTariffCommon";
export var getCurrentFormStep = function getCurrentFormStep(state) {
  return getModalTariffData(state).currentStep;
};
export var getButtonLoadingStatus = function getButtonLoadingStatus(state) {
  return getModalTariffData(state).isLoading || getAddressData(state).isFetched;
};
export var getFlagIsHeaderConfigRender = function getFlagIsHeaderConfigRender(state) {
  var currentStep = getCurrentFormStep(state);
  return currentStep === popupSteps.alternativeTariff;
};
export var getUserAgreementText = createSelector([getOrderTariffTexts, getCurrentFormStep], function (_ref, currentStep) {
  var userAgreement = _ref.userAgreement;
  return orderTariffPopupSteps[currentStep] === orderTariffPopupNames.addressRequestForm ? userAgreement.userAgreementText : null;
});
export var getActiveButtonText = createSelector([getOrderTariffTexts, getCurrentFormStep, getConnectionStatus], function (_ref2, currentStep, connectionStatus) {
  var activeButtonTexts = _ref2.activeButtonTexts;
  return currentStep === popupSteps.addressRequestForm && [POPUP_CONNECTION_STATE.isExists, POPUP_CONNECTION_STATE.alreadyInUse].includes(connectionStatus) ? activeButtonTexts.callBackRequest : activeButtonTexts[resultPopupActionButton[currentStep]];
});
export var getSecondButtonText = createSelector([getOrderTariffTexts, getCurrentFormStep], function (_ref3, currentStep) {
  var activeSecondaryButtonTexts = _ref3.activeSecondaryButtonTexts;
  var result = resultPopupActionButton[currentStep];
  return activeSecondaryButtonTexts[result];
});
export var getButtonDisabledStatus = function getButtonDisabledStatus(state) {
  var currentStep = getCurrentFormStep(state);
  var connectionStatus = getConnectionStatus(state);
  var userPhoneNumber = selectUserCtn(state);
  var isValidPhoneNumber = userPhoneNumber.length === 10;
  var isShowPhoneBlock = selectShouldShowPhoneBlock(state);
  var isAgreementChecked = selectIsCheckboxChecked(state);
  var isPersonalVerificationCheckboxEnable = selectPersonalVerificationCheckboxEnable(state);
  return !(isShowPhoneBlock && isValidPhoneNumber && isAgreementChecked && isPersonalVerificationCheckboxEnable || AVAILABLE_STATUSES.includes(connectionStatus) || currentStep !== popupSteps.addressRequestForm);
};
export var shouldRenderModalButton = createSelector([getCurrentFormStep], function (step) {
  return step !== popupSteps.alternativeTariff;
});
export var shouldRenderSecondButton = createSelector([getCurrentFormStep, getSecondButtonText], function (step, secondButtonText) {
  return [popupSteps.addressRequestForm, popupSteps.addressNotAvailableModal].includes(step) && secondButtonText;
});
export var selectShouldShowPhoneBlock = createSelector([getConnectionStatus], function (statusConnection) {
  return statusConnection === POPUP_CONNECTION_STATE.alreadyInUse || statusConnection === POPUP_CONNECTION_STATE.isExists;
});
export var selectCaptchaTexts = function selectCaptchaTexts(state) {
  return getOrderTariffTexts(state).captchaTexts;
};
export var selectIsCheckboxError = function selectIsCheckboxError(state) {
  return getModalTariffData(state).isCheckboxError;
};
export var selectPhoneInputTexts = function selectPhoneInputTexts(state) {
  return getOrderTariffTexts(state).phoneInputTexts;
};
export var selectFttbCheckAddressOneFieldEnable = function selectFttbCheckAddressOneFieldEnable(state) {
  return getModalTariffData(state).fttbCheckAddressOneFieldEnabled || emptyObj;
};
export var selectCheckAddressOneFieldPopupEnabled = function selectCheckAddressOneFieldPopupEnabled(state) {
  var _selectFttbCheckAddre;
  return (_selectFttbCheckAddre = selectFttbCheckAddressOneFieldEnable(state)) === null || _selectFttbCheckAddre === void 0 ? void 0 : _selectFttbCheckAddre.isOneFieldEnabled;
};

// Чекбокс отображается если настройка PersonalVerificationCheckboxEnable==true
var selectPersonalVerificationCheckboxEnableData = function selectPersonalVerificationCheckboxEnableData(state) {
  return getModalTariffData(state).fttbPersonalVerificationCheckboxEnable;
};
export var selectPersonalVerificationCheckboxEnable = function selectPersonalVerificationCheckboxEnable(state) {
  var _selectPersonalVerifi;
  return (_selectPersonalVerifi = selectPersonalVerificationCheckboxEnableData(state)) === null || _selectPersonalVerifi === void 0 ? void 0 : _selectPersonalVerifi.personalVerificationCheckboxEnable;
};
export var selectIsShowCheckbox = createSelector([selectPersonalVerificationCheckboxEnable, selectPhoneInputTexts], function (personalVerificationCheckboxEnable, _ref4) {
  var checkboxText = _ref4.checkboxText;
  return personalVerificationCheckboxEnable && checkboxText;
});
export var selectUniConstructorRedirectFlag = function selectUniConstructorRedirectFlag(state) {
  return getModalTariffData(state).uniConstructorRedirectFlag;
};